import ShopaholicSearch from "@lovata/shopaholic-search";
import LazyLoad from '@src/js/lazy-load';

export default new class Search {
    constructor() {
        this.searchResultWrapper = 'search-result-wrapper';
        this.searchResultWrapperMobile = 'search-result-wrapper-mobile';
        this.searchResultWrapper404 = 'search-result-error-page-wrapper';
        this.mediaQueryList = window.matchMedia('(min-width: 993px)');
        this.init();
    }
    isDesktop() {
        return this.mediaQueryList.matches;
    }

    init() {
        const obHelper = new ShopaholicSearch();
        obHelper
            .setSearchLimit(5)
            .setSearchDelay(600)
            .setAjaxRequestCallback((obRequestData) => {
                obRequestData.update = {
                    'header/search/search-ajax': `.${this.searchResultWrapper}`,
                    'header/search/search-ajax-full': `.${this.searchResultWrapper404}`
                };
                obRequestData.complete = () => {
                    this.updateAjaxComplete();
                };
                return obRequestData;
            }).init();
    }

    updateAjaxComplete() {
        LazyLoad.update();
    }

}();
